import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactTimeout from 'react-timeout';
import _ from 'lodash';
import checkParentalControls from 'helpers/Pcs';
import {
  checkAuthentication,
  checkAuthenticationOnWindowFocus,
  checkPreviewPass,
  DEVICE_TYPE,
  getAuthentication,
  getEntitlements,
  getMetadata,
  isPreviewPass,
} from 'helpers/auth.clientless';
import {
  OOM_LIVE_PLAYER_URL_COOKIE_NAME,
  getMVPDCookie,
  removeMVPDCookie,
} from 'helpers/ContentHelper';
import { noop } from 'helpers/GlobalHelper';
import { getCookie, setCookie, removeCookie } from 'helpers/Storage';
import { previewPass60MinDisabled } from 'helpers/ConfigHelper';
import { logEvent } from 'helpers/LogReportHelpers';
import { previewPassLogout } from 'helpers/AuthHelper';
import {
  OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT,
  OVERLAY_AUTH_MVPD_START,
  OVERLAY_AUTH_MVPD_SEARCH,
  OVERLAY_AUTH_SUCCESS,
  OVERLAY_AUTH_LOADING,
  OVERLAY_AUTH_FAILURE,
  OVERLAY_AUTH_UPSELL_ERROR,
  OVERLAY_AUTH_UPSELL_CONFIRM,
  defaultState,
  resetState,
  getAuthorizedResources,
} from './AuthHelper';
import {
  CookiesBlocked,
  ExpiredPreviewPass,
  Failure,
  Loading,
  MVPDIncomplete,
  MVPDRetry,
  MVPDSearch,
  MVPDStart,
  MVPDUpsellRedirecting,
  MvpdDirectSignInRedirect,
  NotEntitled,
  PlaybackError,
  PreviewPassWelcome,
  ResumeWithProfile,
  ResumeWithoutProfile,
  SignIn,
  UnlockUpsell,
  Success,
  UpsellConfirm,
  UpsellError,
} from './Overlays';
import { makeSelectAppPCS } from '../Account/AccountComponents/ParentalControls/selectors';

const REQUESTOR = 'fbc-fox';
const PREVIEW_PASS_5_MVPD = 'TempPass_fbcfox_5min';
const PREVIEW_PASS_60_MVPD = 'TempPass_fbcfox_60min';
const PREVIEW_PASS_TRIGGER = 'preview_pass';
const MANUAL_TRIGGER = 'manual';
const RESOURCE_FOX_NEWS = 'FoxNews';
const NETWORK_FNC = 'fnc';

class AuthClientless extends Component {
  static openMvpdWindow = () => window.open('', 'mvpdwindow', null, true);

  static closeMvpdWindow = window => {
    if (!window) return null;

    return window.close();
  };

  constructor(props) {
    super(props);
    this.state = defaultState;
    this.onProviderClick = this.onProviderClick.bind(this);
    this.renderMVPDStart = this.renderMVPDStart.bind(this);
    this.onSignInButtonClick = this.onSignInButtonClick.bind(this);
    this.previewPassLogout = previewPassLogout.bind(this);

    if (props.onRef) {
      props.onRef(this);
    }
  }

  async componentDidMount() {
    const {
      account,
      authorizationToken,
      anonymousId,
      anonymousLogin,
      showNoSportsOnMobileError,
      pcs,
      previewPassExpired,
    } = this.props;

    if (!authorizationToken) await anonymousLogin({ deviceId: anonymousId });

    const mvpdCookie = getMVPDCookie();
    const mvpdName = _.get(mvpdCookie, 'mvpd');
    const isPreviewPassMVPD = isPreviewPass(mvpdName);

    if (!_.isEmpty(pcs) || !account) {
      this.checkAuth();
    } else {
      this.setState({ waitingOnPcs: true });
    }

    if (mvpdCookie) {
      this.setState({ isAuthenticated: true }, () => {
        if (showNoSportsOnMobileError) this.setState({ renderNoSportsOnMobileError: true });

        if (isPreviewPassMVPD && previewPassExpired) {
          this.setState({
            renderExpiredPreviewPass: true,
          });
        }
      });
    }
  }

  // eslint-disable-next-line no-unused-react-component-methods/no-unused-react-component-methods
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      entitlementIssues: nextEntitlementIssues,
      mvpdSignInTrigger: nextMvpdSignInTrigger,
      previewPassExpired: nextPreviewPassExpired,
      requestSignIn,
      setVideoOverlay,
      videoId: nextVideoId,
      triggerAuthCheck: nextTriggerAuthCheck,
    } = nextProps;
    const {
      authenticationSelectProviderStarted,
      entitlementIssues,
      mvpdSignInTrigger,
      previewPassExpired,
      videoId,
      triggerAuthCheck,
    } = this.props;
    const { resumeWithProfileRendered } = this.state;
    const displayPreviewPassExpiredSlate =
      nextPreviewPassExpired && nextPreviewPassExpired !== previewPassExpired;

    if (nextTriggerAuthCheck && !triggerAuthCheck) {
      this.checkAuth();
    }

    if (videoId !== nextVideoId) {
      this.setState({ renderMVPDIncomplete: false, renderExpiredPreviewPass: false });
    }

    if (!resumeWithProfileRendered && requestSignIn) {
      this.setState({
        renderResumeWithProfile: true,
        loading: false,
        resumeWithProfileRendered: true,
      });
      setVideoOverlay(true);
    }

    if (resumeWithProfileRendered && !requestSignIn) {
      this.setState({
        renderResumeWithProfile: false,
        loading: false,
        resumeWithProfileRendered: false,
      });
      setVideoOverlay(false);
    }

    if (displayPreviewPassExpiredSlate) {
      this.setState({
        renderExpiredPreviewPass: true,
        renderResumeWithProfile: false,
        renderResume: false,
        signInTrigger: PREVIEW_PASS_TRIGGER,
      });
      setVideoOverlay(true);
    }

    if (nextMvpdSignInTrigger && nextMvpdSignInTrigger !== mvpdSignInTrigger) {
      authenticationSelectProviderStarted();
      this.onSignInButtonClick();
    }

    if (nextEntitlementIssues !== entitlementIssues) this.setAuthZError(nextEntitlementIssues);
  }

  // eslint-disable-next-line no-unused-react-component-methods/no-unused-react-component-methods
  UNSAFE_componentWillUpdate(nextProps, nextState) {
    const { renderSignIn: nextRenderSignIn } = nextState;
    const { renderCookiesBlocked: nextRenderCookiesBlocked } = nextProps;

    if (nextRenderCookiesBlocked && nextRenderSignIn) this.setState({ renderSignIn: false });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      account,
      contentRating,
      geoLocationDeclined,
      isLive,
      isLiveRestart,
      mvpdExpired,
      pcs,
      previewPassSignIn,
      requestSignIn,
      requiresAuth,
      requiresAuthLive,
      setPreAuthCheckComplete,
      setPreauthorizedResources,
      showNoSportsOnMobileError,
      singleProviderId,
      singleProviderSignInClicked,
      videoId,
    } = this.props;

    const {
      geoLocationDeclined: prevGeoLocationDeclined,
      isLive: prevIsLive,
      isLiveRestart: prevIsLiveRestart,
      mvpdExpired: prevMvpdExpired,
      previewPassSignIn: prevPreviewPassSignIn,
      requestSignIn: prevRequestSignIn,
      requiresAuth: prevRequiresAuth,
      requiresAuthLive: prevRequiresAuthLive,
      showNoSportsOnMobileError: prevShowNoSportsOnMobileError,
      singleProviderSignInClicked: prevSingleProviderSignInClicked,
      videoId: previousVideoId,
    } = prevProps;

    const { preauthorizedResources, renderSignIn, waitingOnPcs } = this.state;
    const { preauthorizedResources: prevPreauthorizedResources } = prevState;
    const geoLocationDeclinedChanged = prevGeoLocationDeclined !== geoLocationDeclined;

    if (previewPassSignIn && previewPassSignIn !== prevPreviewPassSignIn) {
      this.showProviders(PREVIEW_PASS_TRIGGER);
    }

    if (waitingOnPcs && !_.isEmpty(pcs)) {
      this.checkAuth();
      this.setState({ waitingOnPcs: false });
    }
    if (
      (prevPreauthorizedResources &&
        setPreauthorizedResources &&
        _.difference(prevPreauthorizedResources, preauthorizedResources).length) ||
      (!prevPreauthorizedResources && preauthorizedResources)
    ) {
      setPreauthorizedResources(preauthorizedResources);
    }

    if (prevShowNoSportsOnMobileError !== showNoSportsOnMobileError) {
      this.setState({ renderNoSportsOnMobileError: showNoSportsOnMobileError });
    }

    if (geoLocationDeclinedChanged) {
      this.setState({ renderGeoLocationError: geoLocationDeclined });
      this.checkAuth();
    }

    const profilePcsError = !checkParentalControls(account, contentRating, pcs);
    const contentRequiresAuth = (requiresAuthLive && isLive) || (requiresAuth && !isLive);
    const mvpdExpireChanged = prevMvpdExpired !== mvpdExpired;
    const videoIdChanged = videoId !== previousVideoId && !isLiveRestart;
    if (videoIdChanged || mvpdExpireChanged) {
      const prevContentRequiresAuth =
        (prevRequiresAuthLive && prevIsLive) || (prevRequiresAuth && !prevIsLive);
      const requiresAuthChanged = contentRequiresAuth !== prevContentRequiresAuth;
      const requestSignInChanged = prevRequestSignIn && !requestSignIn;
      const liveRestartChanged = prevIsLiveRestart !== isLiveRestart;
      const shouldRecheckAuth =
        liveRestartChanged ||
        mvpdExpireChanged ||
        profilePcsError ||
        requestSignInChanged ||
        requiresAuthChanged;
      if (shouldRecheckAuth) {
        this.onAuthCheckComplete({ complete: false, success: false });
        this.reset();
        this.checkAuth();
      } else {
        setPreAuthCheckComplete(true);
      }
    }

    if (!contentRequiresAuth && prevRequiresAuth && renderSignIn) {
      this.setState({ renderSignIn: false });
    }

    const didClickSingleProviderSignIn =
      singleProviderSignInClicked && !prevSingleProviderSignInClicked;
    if (didClickSingleProviderSignIn) this.onProviderClick(singleProviderId);
  }

  componentWillUnmount() {
    this.clearOverlays();
    this.onAuthCheckComplete({ complete: false, success: false });
  }

  onAuthCheckComplete({ complete, success }) {
    const {
      contentBlackoutActive,
      onAuthCheckComplete,
      requestSignIn,
      renderExpiredPreviewPass,
      setVideoOverlay,
    } = this.props;

    if (complete && success) {
      if (requestSignIn && !renderExpiredPreviewPass && !contentBlackoutActive) {
        setVideoOverlay(true);
        return this.setState({ renderResumeWithProfile: true, loading: false });
      }
    }

    return onAuthCheckComplete({ complete, success });
  }

  async onProviderClick(mvpdId, cookie) {
    const {
      authorizationToken,
      mvpdCookieName,
      onAuthFailure,
      setOverlay,
      setMVPDToAppState,
      handlePopInMiniPlayer,
      isLive,
      isMiniPlayerActive,
      requiresAuth,
      requiresAuthLive,
      resetSingleProviderSignInClicked,
      showSignIn,
      singleProviderId,
      useMVPDRetry,
      setTimeout,
      mvpd,
      mvpdLoginProfile,
      closeAccount,
    } = this.props;
    const { renderMVPDSearch, renderMVPDStart, successTimeout } = this.state;
    if (mvpdLoginProfile) closeAccount();

    const contentRequiresAuth = (requiresAuthLive && isLive) || (requiresAuth && !isLive);
    const authenticationConfig = this.getAuthenticationConfig({ mvpdId });
    const isPreviewPassMvpd =
      mvpd && (mvpd === PREVIEW_PASS_5_MVPD || mvpd === PREVIEW_PASS_60_MVPD);
    const mvpdWindow = AuthClientless.openMvpdWindow();
    let renderLoading = true;

    if (singleProviderId) {
      resetSingleProviderSignInClicked();
      renderLoading = false;
    }

    try {
      if (cookie) setCookie({ ...cookie });
      logEvent('onMVPDSignIn');
      let logoutResponse;
      if (isPreviewPassMvpd) {
        logoutResponse = await this.previewPassLogout();
      }
      const newAuthConfig = {
        ...authenticationConfig,
        accessToken: logoutResponse?.accessToken || authorizationToken,
      };
      const authenticationData = await getAuthentication(newAuthConfig);
      let authenticationUrl = _.get(authenticationData, 'authenticateURL');
      if (!authenticationUrl) {
        AuthClientless.closeMvpdWindow(mvpdWindow);
        return;
      }
      const deviceInfo = _.get(authenticationData, 'deviceInfo');
      if (deviceInfo) authenticationUrl = `${authenticationUrl}&device_info=${deviceInfo}`;
      mvpdWindow.location = authenticationUrl;
      if (renderMVPDStart) setOverlay(OVERLAY_AUTH_MVPD_START, false);
      if (renderMVPDSearch) setOverlay(OVERLAY_AUTH_MVPD_SEARCH, false);
      setOverlay(OVERLAY_AUTH_LOADING, true);
      this.setState({
        renderLoading,
        renderMVPDSearch: false,
        renderMVPDStart: false,
        renderMVPDRetry: false,
        renderSignIn: false,
      });
      const authResult = await checkAuthenticationOnWindowFocus(newAuthConfig);
      const mvpd = _.get(authResult, 'mvpd', null);
      if (!authResult || isPreviewPass(mvpd)) {
        setOverlay(OVERLAY_AUTH_LOADING, false);
        this.setState({
          renderLoading: false,
          renderMVPDIncomplete: true,
        });
        this.togglePreviewPassWelcome(false);
        return;
      }
      AuthClientless.closeMvpdWindow(mvpdWindow);
      const accessToken = _.get(authResult, 'accessToken', null);
      const getEntitlementsOptions = {
        ...authenticationConfig,
        accessToken,
        mvpdCookieName,
        setMVPDToAppState,
      };
      const providerClick = true;
      if (successTimeout) this.clearSuccessTimeOut();
      this.postAuth({ authResult, contentRequiresAuth, getEntitlementsOptions, providerClick });
    } catch (error) {
      console.log('MVPD Login Failure', error);
      const noErrorMessage = error === null;
      const message = error && _.isString(error) ? error : 'User did not authenticate';
      if (setOverlay) setOverlay(OVERLAY_AUTH_FAILURE, false);
      if (showSignIn && !useMVPDRetry) {
        this.setState({ renderFailure: true, renderSignIn: false, renderMVPDSearch: false });
        setTimeout(() => {
          this.setState({ renderFailure: false, renderSignIn: true, renderLoading: false });
          if (isMiniPlayerActive) handlePopInMiniPlayer();
        }, 3000);
      } else if (!singleProviderId) {
        this.setState({
          renderMVPDRetry: !noErrorMessage,
          renderMVPDStart: noErrorMessage,
          renderLoading: false,
          lastMVPDClicked: { mvpdId, cookie },
        });
      }
      onAuthFailure({ mvpdId, err: message });
    }
  }

  togglePreviewPassWelcome(value) {
    this.setState({ renderPreviewPassWelcome: value });
  }

  onSignInButtonClick() {
    const { signInOnButtonClick, setOverlay, profileId, setMVPDSignInTrigger } = this.props;

    setOverlay(OVERLAY_AUTH_MVPD_START, true);
    this.setState({
      renderMVPDIncomplete: false,
      renderSignIn: false,
      renderMVPDStart: true,
      previewPassSignIn: false,
    });
    signInOnButtonClick({ profileId });
    setMVPDSignInTrigger(false);
  }

  retryMVPDButtonClick = () => {
    const { lastMVPDClicked } = this.state;
    const { mvpdId, cookie } = lastMVPDClicked;
    this.onProviderClick(mvpdId, cookie);
  };

  setAuthZError(entitlementIssues) {
    const {
      authZErrorMapping,
      setAuthError,
      handlePopInMiniPlayer,
      isMiniPlayerActive,
    } = this.props;
    if (_.isEmpty(entitlementIssues)) {
      setAuthError(false);
      this.setState({ renderPlaybackError: false });
      return;
    }
    const statusCode = _.get(entitlementIssues, '0.statusCode');
    const errorCode = _.get(entitlementIssues, '0.errorCode');
    const defaultText = _.get(authZErrorMapping, 'default');
    const messageText = _.get(entitlementIssues, '0.message');
    const playbackErrorText = _.get(authZErrorMapping, `${statusCode}.${errorCode}`, defaultText);
    if (messageText) {
      playbackErrorText.header = messageText;
    }
    setAuthError(true);
    if (errorCode === 1005) {
      this.showProviders();
    } else {
      this.setState({ renderPlaybackError: true, playbackErrorText });
      if (isMiniPlayerActive) handlePopInMiniPlayer();
    }
  }

  setNoEntitlementsError() {
    const { handlePopInMiniPlayer, isMiniPlayerActive } = this.props;
    const { auth_noEntitlements: contentHeader } = window.Language;
    const playbackErrorText = { header: contentHeader };
    this.setState({ renderPlaybackError: true, playbackErrorText });
    if (isMiniPlayerActive) handlePopInMiniPlayer();
  }

  getPreviewPassConfig = (opts = {}) => {
    const { mvpdId } = opts;
    const {
      apiKey,
      authEndpointConfig,
      authorizationToken,
      deviceId,
      mvpdCookieName,
      setMVPDToAppState,
    } = this.props;
    return {
      authEndpointConfig: {
        ...authEndpointConfig,
        apiKey,
      },
      mvpdId,
      deviceId,
      accessToken: authorizationToken,
      mvpdCookieName,
      setMVPDToAppState,
    };
  };

  getAuthenticationConfig = (opts = {}) => {
    const { mvpdId } = opts;
    const {
      apiKey,
      authEndpointConfig,
      authenticationRedirectUrl,
      authorizationToken,
      deviceId,
      model,
      mvpdCookieName,
      osName,
      setMVPDToAppState,
    } = this.props;
    const isPreviewPassMvpd = mvpdId === PREVIEW_PASS_5_MVPD || mvpdId === PREVIEW_PASS_60_MVPD;
    const redirectUrl = isPreviewPassMvpd ? null : authenticationRedirectUrl;
    return {
      appVersion: DEVICE_TYPE,
      authEndpointConfig: {
        ...authEndpointConfig,
        apiKey,
      },
      deviceId,
      deviceType: DEVICE_TYPE,
      firstScreen: true,
      accessToken: authorizationToken,
      model,
      mvpdCookieName,
      mvpdId,
      osName,
      redirectUrl,
      requestor: REQUESTOR,
      setMVPDToAppState,
    };
  };

  clearOverlays = () => {
    const { setOverlay } = this.props;
    if (setOverlay) {
      const overlays = [
        OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT,
        OVERLAY_AUTH_MVPD_START,
        OVERLAY_AUTH_MVPD_SEARCH,
        OVERLAY_AUTH_SUCCESS,
        OVERLAY_AUTH_LOADING,
        OVERLAY_AUTH_FAILURE,
        OVERLAY_AUTH_UPSELL_ERROR,
        OVERLAY_AUTH_UPSELL_CONFIRM,
      ];
      overlays.forEach(overlay => setOverlay(overlay, false));
    }
  };

  showProviders(signInTrigger = MANUAL_TRIGGER) {
    const {
      handlePopInMiniPlayer,
      isMiniPlayerActive,
      mvpdExpired,
      setIsAuthenticated,
      setOverlay,
      showSignIn,
    } = this.props;
    const { renderExpiredPreviewPass } = this.state;
    this.reset();

    const nextState = {
      loading: false,
      previewPassSignIn: false,
      signInTrigger,
    };
    if (mvpdExpired) {
      if (!renderExpiredPreviewPass) {
        nextState.renderMVPDExpireSignIn = true;
        nextState.renderMVPDStart = false;
        nextState.renderExpiredPreviewPass = false;
        if (isMiniPlayerActive) handlePopInMiniPlayer();
      }
    } else if (showSignIn) {
      if (!renderExpiredPreviewPass) {
        nextState.renderSignIn = true;
        nextState.renderMVPDStart = false;
        nextState.renderExpiredPreviewPass = false;
        if (isMiniPlayerActive) handlePopInMiniPlayer();
      }
    } else {
      nextState.renderMVPDStart = true;
      nextState.renderSignIn = false;
      nextState.renderExpiredPreviewPass = false;
      setOverlay(OVERLAY_AUTH_MVPD_START, true);
    }
    this.setState(nextState, () => {
      if (signInTrigger !== PREVIEW_PASS_TRIGGER) {
        removeMVPDCookie({ options: { path: '/' } });
        setIsAuthenticated(false);
      }
    });
  }

  handleProfilePcsError() {
    const { setAuthError, setVideoOverlay, ratingNoAuthZText } = this.props;
    setAuthError(true);
    setVideoOverlay(true);
    this.setState({ renderProfilePcsError: true, playbackErrorText: ratingNoAuthZText });
  }

  async postAuth({ authResult, contentRequiresAuth, getEntitlementsOptions, providerClick }) {
    const {
      additionalAuthorizedNetworks,
      authorizationToken,
      blockSuccessScreen,
      isTveEnabled,
      network,
      onAuthSuccess,
      selectedChannel,
      setAuthorizationToken,
      setIsAuthenticated,
      setOverlay,
      setProvider,
      setToken,
      setVideoOverlay,
      showLoaderAfterAuth,
      showProvidersHandler,
      singleProviderId,
      successCookieName,
      type,
    } = this.props;
    const { renderMVPDSearch, renderMVPDStart, renderLoading } = this.state;
    const accessToken = _.get(authResult, 'accessToken');
    const isAuthenticated = !!accessToken;
    let metadata;

    setVideoOverlay(false);
    // If not authenticated, set state to false, otherwise wait
    // until entitlements are populated to update app isAuthed state
    if (!isAuthenticated) setIsAuthenticated(isAuthenticated);

    if (isAuthenticated) {
      const MVPD = _.get(authResult, 'mvpd');
      const provider = { MVPD };
      let getEntitlementsResult;
      setAuthorizationToken(accessToken);
      setProvider(MVPD);

      try {
        getEntitlementsResult = await getEntitlements(getEntitlementsOptions);
      } catch (error) {
        console.log('getEntitlements error', error);
      }

      const entitlements = _.get(getEntitlementsResult, 'entitlements', {});
      const preauthorizedResources = _.keys(entitlements);
      const hasFNCEntitlements = preauthorizedResources.includes(RESOURCE_FOX_NEWS);
      const isFNCContent = network === NETWORK_FNC;

      const authorizedResources = getAuthorizedResources(
        preauthorizedResources,
        additionalAuthorizedNetworks,
      );
      const nextState = {
        successResources: preauthorizedResources,
        preauthorizedResources: authorizedResources,
        renderMVPDSearch: false,
        renderMVPDStart: false,
        renderMVPDIncomplete: false,
        renderLoading: showLoaderAfterAuth,
        authResult,
        loading: false,
        isAuthenticated,
      };

      if (isFNCContent && !hasFNCEntitlements) {
        nextState.renderNotEntitled = true;
        this.setState(nextState);
        return;
      }

      setIsAuthenticated(isAuthenticated);

      try {
        metadata = await getMetadata(getEntitlementsOptions);
        const { hbaStatus } = metadata;
        setToken({ hbaStatus });
      } catch (error) {
        console.log('getMetadata error', error);
      }

      // LIVE/Restart (or VOD playbak initiated with releaseUrl instead of videoId)
      // When programs switch
      const { baseChannel } = this.state;

      // Since we would still want to check the parental controls
      // we should still do this check since different programs on the same channel
      // will have different ratings
      if (type === 'live' && baseChannel !== selectedChannel)
        nextState.baseChannel = selectedChannel;
      const cookie = getCookie({ name: successCookieName });

      let renderSuccessNext;

      if (cookie) {
        removeCookie({ key: successCookieName, options: { path: '/' } });
        const mvpdCookie = getMVPDCookie();
        const mvpd = _.get(mvpdCookie, 'mvpd', null);
        renderSuccessNext = !blockSuccessScreen && !isPreviewPass(mvpd);
        nextState.renderSuccess = renderSuccessNext;
      }

      this.setState(nextState, () => {
        if (!renderSuccessNext) this.onAuthCheckComplete({ complete: true, success: true });
      });

      if (setOverlay) {
        if (renderLoading) setOverlay(OVERLAY_AUTH_LOADING, false);
        if (renderSuccessNext) {
          setOverlay(OVERLAY_AUTH_SUCCESS, true);
        }
        if (renderMVPDStart) setOverlay(OVERLAY_AUTH_MVPD_START, false);
        if (renderMVPDSearch) setOverlay(OVERLAY_AUTH_MVPD_SEARCH, false);
      }

      onAuthSuccess({ provider, entitlements: authorizedResources, cookie, providerClick });
      showProvidersHandler({ show: false });
    } else if (contentRequiresAuth && !isTveEnabled) {
      this.onAuthCheckComplete({ complete: true, success: false });
      this.setNoEntitlementsError();
    } else if (contentRequiresAuth || !authorizationToken) {
      this.onAuthCheckComplete({ complete: true, success: false });
      if (!singleProviderId) {
        this.showProviders();
        showProvidersHandler({ show: true });
      }
      if (setOverlay && renderMVPDSearch) setOverlay(OVERLAY_AUTH_MVPD_SEARCH, false);
      this.setState({
        renderMVPDSearch: false,
        renderMVPDIncomplete: false,
        loading: false,
        isAuthenticated,
      });
    } else {
      this.onAuthCheckComplete({ complete: true, success: true });
      showProvidersHandler({ show: false });
    }
  }

  authenticatePreviewPass = (options = {}) =>
    new Promise(async resolve => {
      const { mvpdId } = options;
      try {
        const authenticationConfig = this.getPreviewPassConfig({ mvpdId });
        const authenticationData = await checkPreviewPass(authenticationConfig);
        resolve(authenticationData);
      } catch (e) {
        console.log(`Preview Pass ${mvpdId} Not Available`);
        resolve();
      }
    });

  tryPreviewPass = () =>
    new Promise(async (resolve, reject) => {
      try {
        const pass60minute = await this.authenticatePreviewPass({ mvpdId: PREVIEW_PASS_60_MVPD });
        if (pass60minute && !previewPass60MinDisabled()) return resolve(pass60minute);
        const pass5minute = await this.authenticatePreviewPass({ mvpdId: PREVIEW_PASS_5_MVPD });
        if (pass5minute) return resolve(pass5minute);
        throw new Error('Preview Passes Currently Unavailable');
      } catch (e) {
        return reject(e);
      }
    });

  async checkAuth() {
    const {
      apiKey,
      authEndpointConfig,
      authorizationToken,
      shouldCheckPreviewPass,
      deviceId,
      fetchMVPDProviders,
      isLive,
      isTveEnabled,
      contentRating,
      mvpdCookieName,
      geoLocationDeclined,
      account,
      selectedChannel,
      releaseURL,
      setMVPDToAppState,
      setPreAuthCheckComplete,
      setVideoOverlay,
      requiresAuth,
      requiresAuthLive,
      previewPassEnabled,
      pcs,
    } = this.props;
    setPreAuthCheckComplete(true);
    this.onAuthCheckComplete({ complete: false });
    const { baseChannel, successTimeOut } = this.state;
    const contentRequiresAuth = (requiresAuthLive && isLive) || (requiresAuth && !isLive);
    const profilePcsError = !checkParentalControls(account, contentRating, pcs);
    const isOutOfMarketLivePage = getCookie({ name: OOM_LIVE_PLAYER_URL_COOKIE_NAME });

    if (geoLocationDeclined && !isOutOfMarketLivePage) {
      setVideoOverlay(true);
      this.setState({ renderGeoLocationError: true, loading: false });
      return;
    }

    if (profilePcsError) {
      this.handleProfilePcsError();
      return;
    }

    if (isLive && !releaseURL && baseChannel !== selectedChannel) {
      this.setState({ baseChannel: null });
    }

    if (isTveEnabled) fetchMVPDProviders(deviceId);
    this.setState({ loading: true, renderPlaybackError: false });
    try {
      const checkAuthOptions = {
        authEndpointConfig: { ...authEndpointConfig, apiKey },
        deviceType: DEVICE_TYPE,
        requestor: REQUESTOR,
        deviceId,
        mvpdCookieName,
        accessToken: authorizationToken,
        setMVPDToAppState,
      };

      let checkAuthResult;
      let previewPass;

      try {
        if (isTveEnabled) checkAuthResult = await checkAuthentication(checkAuthOptions);
      } catch (error) {
        console.log('checkAuthentication failed', error);
      }

      try {
        const tryPreviewPass =
          !checkAuthResult &&
          contentRequiresAuth &&
          previewPassEnabled &&
          shouldCheckPreviewPass &&
          isTveEnabled;
        if (tryPreviewPass) {
          previewPass = await this.tryPreviewPass();
        }
      } catch (e) {
        console.log('preview pass failed', e);
      }

      const authResult = checkAuthResult || previewPass;
      const accessToken = _.get(authResult, 'accessToken');

      const getEntitlementsOptions = {
        ...checkAuthOptions,
        accessToken,
        mvpdCookieName,
        setMVPDToAppState,
      };

      if (successTimeOut) this.clearSuccessTimeOut();
      this.postAuth({ authResult, contentRequiresAuth, getEntitlementsOptions });
    } catch (error) {
      console.log('AuthClientless checkAuth error', error);
    }
  }

  reset() {
    const { setAuthError } = this.props;
    if (_.isEqual(this.state, resetState)) return;
    console.log('reset state');
    this.setState({ ...resetState });
    setAuthError(false);
  }

  startSuccessTimeOut() {
    const { setTimeout, setOverlay } = this.props;
    const successTimeOut = setTimeout(() => {
      setOverlay(OVERLAY_AUTH_SUCCESS, false);
      this.onAuthCheckComplete({ complete: true, success: true });
      this.setState({
        renderSuccess: false,
        authResult: null,
      });
    }, 3000);
    this.setState({ successTimeOut });
  }

  clearSuccessTimeOut() {
    const { successTimeOut } = this.state;
    const { clearTimeout } = this.props;
    clearTimeout(successTimeOut);
    this.setState({ successTimeOut: null });
  }

  renderSignIn() {
    const {
      authenticationSelectProviderStarted,
      background,
      backgroundInline,
      networkLogo,
      previewPassExpired,
      setSegmentPageStartSource,
      setOverlay,
      sharedTheme,
      showProvidersHandler,
      signInButtonText,
      signInInvertContent,
      signInPerks,
      signInText,
      signInTheme,
    } = this.props;
    const { renderSignIn, signInTrigger } = this.state;
    const onClose = () => {
      setOverlay(OVERLAY_AUTH_MVPD_START, false);
      this.setState(
        {
          renderSignIn: false,
          renderMVPDStart: false,
          renderResumeWithProfile: false,
        },
        () => {
          this.checkAuth();
          showProvidersHandler({ show: false, keepVideoPaused: false });
        },
      );
    };

    const signInClose =
      signInTrigger === PREVIEW_PASS_TRIGGER && !previewPassExpired ? onClose : undefined;

    let content = (
      <>
        {signInText}
        {signInPerks}
      </>
    );

    if (signInInvertContent) {
      content = (
        <>
          {signInPerks}
          {signInText}
        </>
      );
    }

    return (
      <SignIn
        key="signin"
        rendered={renderSignIn}
        buttonOnClick={() => {
          setSegmentPageStartSource({ previewPassSignIn: true });
          authenticationSelectProviderStarted();
          this.onSignInButtonClick();
        }}
        onClose={signInClose}
        imgSrc={networkLogo}
        buttonItem={signInButtonText}
        backgroundInline={backgroundInline}
        bgImgSrc={background}
        theme={signInTheme}
        sharedTheme={sharedTheme}
      >
        {content}
      </SignIn>
    );
  }

  renderMVPDExpireSignIn() {
    const {
      authenticationSelectProviderStarted,
      background,
      backgroundInline,
      networkLogo,
      previewPassExpired,
      setSegmentPageStartSource,
      setOverlay,
      sharedTheme,
      showProvidersHandler,
      signInButtonText,
      signInInvertContent,
      signInPerks,
      signInTheme,
    } = this.props;
    const { profileMvpdExpired_header: expiredHeaderText } = window.Language;
    const { renderMVPDExpireSignIn, signInTrigger } = this.state;
    const onClose = () => {
      setOverlay(OVERLAY_AUTH_MVPD_START, false);
      this.setState(
        {
          renderMVPDExpireSignIn: false,
          renderMVPDStart: false,
          renderResumeWithProfile: false,
        },
        () => {
          this.checkAuth();
          showProvidersHandler({ show: false, keepVideoPaused: true });
        },
      );
    };
    const signInClose =
      signInTrigger === PREVIEW_PASS_TRIGGER && !previewPassExpired ? onClose : undefined;
    const content = signInInvertContent
      ? [signInPerks, expiredHeaderText]
      : [expiredHeaderText, signInPerks];
    return renderMVPDExpireSignIn ? (
      <div className={signInTheme.expiredMVPD}>
        <SignIn
          key="signin"
          rendered={renderMVPDExpireSignIn}
          buttonOnClick={() => {
            setSegmentPageStartSource({ previewPassSignIn: true });
            authenticationSelectProviderStarted();
            this.onSignInButtonClick();
          }}
          onClose={signInClose}
          imgSrc={networkLogo}
          buttonItem={signInButtonText}
          backgroundInline={backgroundInline}
          bgImgSrc={background}
          theme={signInTheme}
          sharedTheme={sharedTheme}
        >
          {content}
        </SignIn>
      </div>
    ) : null;
  }

  renderUnlockUpsell() {
    const { unlockUpsellPerks, unlockUpsellText, unlockUpsellInButtonText } = this.props;
    const { renderUnlockUpsell } = this.state;
    return (
      <UnlockUpsell buttonText={unlockUpsellInButtonText} rendered={renderUnlockUpsell}>
        {unlockUpsellPerks}
        {unlockUpsellText}
      </UnlockUpsell>
    );
  }

  renderSuccess() {
    const {
      backgroundUrl,
      mvpd,
      mvpdStartBackgroundClass,
      sharedTheme,
      successInnerContainerChildren,
      successTheme,
    } = this.props;
    const { renderSuccess, successResources } = this.state;

    const innerContainerChildrenParams = {
      preauthorizedResources: successResources,
      mvpd,
    };

    return (
      <Success
        key="success"
        rendered={renderSuccess}
        theme={successTheme}
        sharedTheme={sharedTheme}
        backgroundClass={mvpdStartBackgroundClass}
        backgroundUrl={backgroundUrl}
        innerContainerChildren={successInnerContainerChildren}
        innerContainerChildrenParams={innerContainerChildrenParams}
      />
    );
  }

  renderMVPDUpsellRedirecting() {
    const {
      backgroundUrl,
      handlePopInMiniPlayer,
      isMiniPlayerActive,
      redirectingTheme,
      sharedTheme,
      redirectingInnerContainerChildren,
      redirectingBackgroundClass,
      redirectingOnClose,
      setOverlay,
      setVideoOverlay,
    } = this.props;
    const { renderMVPDUpsellRedirecting } = this.state;
    const onClose = () => {
      setOverlay(OVERLAY_AUTH_LOADING, false);
      this.setState({
        renderSignIn: false,
        renderMVPDUpsellRedirecting: false,
        renderMVPDStart: false,
        renderMVPDIncomplete: true,
      });
      if (isMiniPlayerActive) handlePopInMiniPlayer();
      setVideoOverlay(true);
      if (redirectingOnClose) redirectingOnClose();
    };
    const onConfirm = () => {
      const { upsellUrl } = this.state;
      const mvpdWindow = AuthClientless.openMvpdWindow();
      this.setState({
        renderUpsellConfirm: true,
        renderMVPDUpsellRedirecting: false,
      });
      setOverlay(OVERLAY_AUTH_UPSELL_CONFIRM);
      mvpdWindow.location = upsellUrl;
    };
    const innerContainerChildrenParams = { onClose, onConfirm };
    return (
      <MVPDUpsellRedirecting
        key="Redirecting"
        rendered={renderMVPDUpsellRedirecting}
        theme={redirectingTheme}
        sharedTheme={sharedTheme}
        backgroundClass={redirectingBackgroundClass}
        backgroundUrl={backgroundUrl}
        innerContainerChildren={redirectingInnerContainerChildren}
        innerContainerChildrenParams={innerContainerChildrenParams}
      />
    );
  }

  renderLoading() {
    const {
      backgroundUrl,
      loadingTheme,
      sharedTheme,
      loadingInnerContainerChildren,
      loadingBackgroundClass,
      setOverlay,
      setVideoOverlay,
      loadingOnClose,
    } = this.props;
    const { renderLoading } = this.state;
    const onClose = () => {
      const newState = {
        renderSignIn: false,
        renderLoading: false,
        renderMVPDStart: false,
        renderMVPDIncomplete: true,
      };

      this.setState(newState);
      setOverlay(OVERLAY_AUTH_LOADING, false);
      setVideoOverlay(true);
      if (loadingOnClose) loadingOnClose();
    };
    const innerContainerChildrenParams = { onClose };
    return (
      <Loading
        backgroundUrl={backgroundUrl}
        key="loading"
        rendered={renderLoading}
        theme={loadingTheme}
        sharedTheme={sharedTheme}
        backgroundClass={loadingBackgroundClass}
        innerContainerChildren={loadingInnerContainerChildren}
        innerContainerChildrenParams={innerContainerChildrenParams}
      />
    );
  }

  renderFailure() {
    const { failureTheme, sharedTheme, contentChildren, backgroundInline } = this.props;
    const { renderFailure } = this.state;
    const onConfirmClick = () => {
      this.setState({
        renderFailure: false,
      });
    };
    const contentChildrenParams = { onConfirmClick };
    return (
      <Failure
        key="failure"
        rendered={renderFailure}
        theme={failureTheme}
        sharedTheme={sharedTheme}
        contentChildren={contentChildren}
        contentChildrenParams={contentChildrenParams}
        backgroundInline={backgroundInline}
      />
    );
  }

  renderCookiesBlocked() {
    const {
      sharedTheme,
      getCookiesBlockedChildren,
      cookiesBlockedTheme,
      backgroundInline,
      renderCookiesBlocked,
      signInButtonText,
      resetShowCookiesBlocked,
    } = this.props;
    return (
      <CookiesBlocked
        options={{
          key: 'cookies-blocked',
          rendered: renderCookiesBlocked,
          theme: cookiesBlockedTheme,
          sharedTheme,
          backgroundInline,
          onSignInButtonClick: this.onSignInButtonClick,
          signInButtonText,
          resetShowCookiesBlocked,
          getChildren: getCookiesBlockedChildren,
        }}
      />
    );
  }

  renderPlaybackError() {
    const { playbackErrorTheme, sharedTheme, playbackErrorChildren, backgroundInline } = this.props;
    const { renderPlaybackError, playbackErrorText } = this.state;
    return (
      <PlaybackError
        key="playback-error"
        rendered={renderPlaybackError}
        theme={playbackErrorTheme}
        sharedTheme={sharedTheme}
        backgroundInline={backgroundInline}
        className="dcg-playback-error"
      >
        {playbackErrorChildren({ errorText: playbackErrorText })}
      </PlaybackError>
    );
  }

  renderGeoLocationError() {
    const {
      playbackErrorTheme,
      sharedTheme,
      geoLocationErrorChildren,
      backgroundInline,
      geoLocationText,
      geoLocationTimeoutFail,
      geoLocationPrimaryActionCallback,
    } = this.props;
    const { renderGeoLocationError } = this.state;

    if (!geoLocationErrorChildren) return null;

    return (
      <PlaybackError
        key="geolocation-error"
        rendered={renderGeoLocationError}
        theme={playbackErrorTheme}
        sharedTheme={sharedTheme}
        backgroundInline={backgroundInline}
        className="dcg-playback-error"
      >
        {geoLocationErrorChildren({
          errorText: geoLocationText,
          primaryActionCallback: geoLocationPrimaryActionCallback,
          geoLocationTimeoutFail,
        })}
      </PlaybackError>
    );
  }

  renderProfilePcsError() {
    const {
      profilePcsErrorTheme,
      sharedTheme,
      profilePcsErrorChildren,
      backgroundInline,
    } = this.props;
    const { renderProfilePcsError, playbackErrorText } = this.state;

    return (
      <PlaybackError
        key="profile-pcs-error"
        rendered={renderProfilePcsError}
        theme={profilePcsErrorTheme}
        sharedTheme={sharedTheme}
        backgroundInline={backgroundInline}
        className="dcg-playback-error"
      >
        {profilePcsErrorChildren({ errorText: playbackErrorText })}
      </PlaybackError>
    );
  }

  /**
   * No soup for you!  :-(
   */
  renderNoSportsOnMobile() {
    const {
      playbackErrorTheme,
      sharedTheme,
      noSportsOnMobileErrorChildren,
      backgroundInline,
      noSportsText,
    } = this.props;
    const { renderNoSportsOnMobileError } = this.state;

    if (!noSportsOnMobileErrorChildren) return null;

    return (
      <PlaybackError
        key="nosportsonmobile-error"
        rendered={renderNoSportsOnMobileError}
        theme={playbackErrorTheme}
        sharedTheme={sharedTheme}
        backgroundInline={backgroundInline}
        className="dcg-playback-error"
      >
        {noSportsOnMobileErrorChildren({ errorText: noSportsText })}
      </PlaybackError>
    );
  }

  renderMVPDStart() {
    // TODO: refactor out mvpd start + mvpd search and replace with video provider search if the optimizely test switches to become the default user experience
    const {
      authenticationStarted,
      backgroundUrl,
      isLive,
      isMobile,
      isTablet,
      mvpdSignInTrigger,
      mvpdStartBackgroundClass,
      mvpdStartChildren,
      mvpdStartInnerContainerChildren,
      mvpdStartOnClose,
      previewPassExpired,
      previewPassSignIn,
      profileId,
      renderVideoProviderSearch,
      selectedChannel,
      setMVPDSignInTrigger,
      setOverlay,
      setVideoOverlay,
      sharedTheme,
      tealiumAuthenticationStarted,
      tvProviderFeatListViewed,
    } = this.props;
    const { renderMVPDStart, preauthorizedResources } = this.state;
    const useOptimizelyExperiment =
      window.optimizelyQuickMvpdFlow && !isMobile && !isTablet && renderMVPDStart;
    const shouldShowOverlays = !mvpdSignInTrigger;

    const onClose = () => {
      const newState = {
        renderSignIn: false,
        renderMVPDStart: false,
        renderMVPDIncomplete: shouldShowOverlays,
      };

      this.setState(newState);

      setOverlay(OVERLAY_AUTH_MVPD_START, false);
      setVideoOverlay(shouldShowOverlays);
      setMVPDSignInTrigger(false);
      if (mvpdStartOnClose) mvpdStartOnClose();
    };

    if (useOptimizelyExperiment) {
      return renderVideoProviderSearch({
        onClose,
        onProviderClick: this.onProviderClick,
        selectedChannel,
        isLive,
        preauthorizedResources,
        previewPassSignIn,
        previewPassExpired,
        profileId,
      });
    }

    const onAllProvidersClick = () => {
      setOverlay(OVERLAY_AUTH_MVPD_SEARCH, true);
      this.setState({
        renderMVPDStart: false,
        renderMVPDSearch: true,
        renderMVPDIncomplete: false,
      });
    };

    const innerContainerChildrenParams = { onClose };

    return (
      <MVPDStart
        key="start"
        rendered={renderMVPDStart}
        sharedTheme={sharedTheme}
        backgroundClass={mvpdStartBackgroundClass}
        backgroundUrl={backgroundUrl}
        innerContainerChildren={mvpdStartInnerContainerChildren}
        innerContainerChildrenParams={innerContainerChildrenParams}
        tvProviderFeatListViewed={tvProviderFeatListViewed}
        authenticationStarted={authenticationStarted}
        tealiumAuthenticationStarted={tealiumAuthenticationStarted}
      >
        {mvpdStartChildren({
          onProviderClick: this.onProviderClick,
          onAllProvidersClick,
          onClose,
          selectedChannel,
        })}
      </MVPDStart>
    );
  }

  renderMVPDSearch() {
    const {
      backgroundUrl,
      isLive,
      mvpdSearchBackgroundClass,
      mvpdSearchChildren,
      mvpdSearchInnerContainerChildren,
      mvpdSearchInput,
      mvpdSearchOnClose,
      mvpdSearchOnInputChange,
      mvpdSearchResults,
      mvpdSearchTheme,
      previewPassExpired,
      previewPassSignIn,
      profileId,
      renderVideoProviderSearch,
      selectedChannel,
      setOverlay,
      setVideoOverlay,
      sharedTheme,
      tvProviderFullListViewed,
    } = this.props;

    const { renderMVPDSearch, preauthorizedResources } = this.state;
    const shouldRenderProviderSearch = false;
    const onClose = () => {
      const newState = {
        renderSignIn: false,
        renderMVPDSearch: false,
        renderMVPDIncomplete: true,
      };

      this.setState(newState);
      setOverlay(OVERLAY_AUTH_MVPD_SEARCH, false);
      setVideoOverlay(true);
      if (mvpdSearchOnClose) mvpdSearchOnClose();
    };

    if (shouldRenderProviderSearch) {
      return renderVideoProviderSearch({
        backgroundUrl,
        onClose,
        onProviderClick: this.onProviderClick,
        selectedChannel,
        isLive,
        preauthorizedResources,
        previewPassSignIn,
        previewPassExpired,
        profileId,
      });
    }

    const onBack = () => {
      setOverlay(OVERLAY_AUTH_MVPD_START, true);
      this.setState({
        renderMVPDStart: true,
        renderMVPDSearch: false,
        renderMVPDIncomplete: false,
      });
    };

    const innerContainerChildrenParams = { onClose };
    return (
      <MVPDSearch
        key="search"
        rendered={renderMVPDSearch}
        sharedTheme={sharedTheme}
        backgroundClass={mvpdSearchBackgroundClass}
        backgroundUrl={backgroundUrl}
        theme={mvpdSearchTheme}
        innerContainerChildren={mvpdSearchInnerContainerChildren}
        innerContainerChildrenParams={innerContainerChildrenParams}
        searchResults={mvpdSearchResults}
        searchInput={mvpdSearchInput}
        selectedChannel={selectedChannel}
        onInputChange={mvpdSearchOnInputChange}
        onResultClick={this.onProviderClick}
        onBackClick={onBack}
        tvProviderFullListViewed={tvProviderFullListViewed}
      >
        {mvpdSearchChildren}
      </MVPDSearch>
    );
  }

  renderMVPDIncomplete() {
    const {
      authenticationSelectProviderStarted,
      backgroundInline,
      blockMVPDIncomplete,
      mvpdIncompleteChildren,
      mvpdIncompleteTheme,
      previewPassExpired,
      previewPassSignIn,
      setOverlay,
      setSegmentPageStartSource,
      sharedTheme,
      showProvidersHandler,
    } = this.props;
    const { renderMVPDIncomplete } = this.state;

    const onClose = () => {
      setOverlay(OVERLAY_AUTH_MVPD_START, false);
      this.setState(
        {
          renderMVPDIncomplete: false,
          renderSignIn: false,
          renderIframe: false,
          renderMVPDStart: false,
          renderResumeWithProfile: false,
          previewPassSignIn: false,
        },
        () => {
          this.checkAuth();
          showProvidersHandler({ show: false, keepVideoPaused: false });
        },
      );
    };

    const signInClose = previewPassSignIn && !previewPassExpired ? onClose : undefined;
    return (
      <MVPDIncomplete
        isActive={!blockMVPDIncomplete && renderMVPDIncomplete}
        onClose={signInClose}
        backgroundInline={backgroundInline}
        sharedTheme={sharedTheme}
        mvpdIncompleteTheme={mvpdIncompleteTheme}
        mvpdIncompleteChildren={mvpdIncompleteChildren}
        buttonOnClick={() => {
          setSegmentPageStartSource({ MVPDIncomplete: true });
          authenticationSelectProviderStarted();
          this.onSignInButtonClick();
        }}
      />
    );
  }

  renderMVPDRetry() {
    const {
      backgroundInline,
      backgroundUrl,
      loadingBackgroundClass,
      loadingOnClose,
      mvpdRetryChildren,
      mvpdRetryTheme,
      sharedTheme,
    } = this.props;
    const { renderMVPDRetry } = this.state;
    const onClose = () => {
      const newState = {
        renderSignIn: false,
        renderLoading: false,
        renderMVPDStart: false,
        renderMVPDRetry: false,
      };

      this.setState(newState);
      if (loadingOnClose) loadingOnClose();
    };

    const returnToMVPDSelect = () => {
      this.setState({
        renderMVPDRetry: false,
        renderMVPDStart: true,
      });
    };

    return (
      <MVPDRetry
        isActive={renderMVPDRetry}
        onCloseClick={onClose}
        buttonOnClick={onClose}
        backgroundInline={backgroundInline}
        backgroundClass={loadingBackgroundClass}
        backgroundUrl={backgroundUrl}
        sharedTheme={sharedTheme}
        mvpdRetryTheme={mvpdRetryTheme}
        mvpdRetryChildren={mvpdRetryChildren}
        retryButtonClick={this.retryMVPDButtonClick}
        otherProviderClick={returnToMVPDSelect}
      />
    );
  }

  renderNotEntitled() {
    const {
      backgroundInline,
      backgroundUrl,
      loadingBackgroundClass,
      loadingOnClose,
      notEntitledChildren,
      notEntitledTheme,
      sharedTheme,
    } = this.props;
    const { renderNotEntitled } = this.state;
    const onClose = () => {
      this.setState({
        renderSignIn: false,
        renderLoading: false,
        renderMVPDStart: false,
        renderMVPDRetry: false,
        renderNotEntitled: false,
      });
      if (loadingOnClose) loadingOnClose();
    };

    return (
      <NotEntitled
        isActive={renderNotEntitled}
        onCloseClick={onClose}
        backgroundInline={backgroundInline}
        backgroundClass={loadingBackgroundClass}
        backgroundUrl={backgroundUrl}
        sharedTheme={sharedTheme}
        notEntitledTheme={notEntitledTheme}
        notEntitledChildren={notEntitledChildren}
      />
    );
  }

  renderExpiredPreviewPass() {
    const {
      authenticationSelectProviderStarted,
      setOverlay,
      previewPassOnOpenOverlay,
      backgroundInline,
      setSegmentPageStartSource,
      sharedTheme,
    } = this.props;
    const { renderExpiredPreviewPass } = this.state;
    const openOverlay = () => {
      if (previewPassOnOpenOverlay) previewPassOnOpenOverlay();
      setOverlay(OVERLAY_AUTH_MVPD_START, true);
      setSegmentPageStartSource({ previewPassExpired: true });
      authenticationSelectProviderStarted();
      this.setState({
        renderMVPDStart: true,
        renderMVPDSearch: false,
        renderExpiredPreviewPass: false,
      });
    };

    return (
      <ExpiredPreviewPass
        setOverlay={setOverlay}
        openOverlay={openOverlay}
        isActive={renderExpiredPreviewPass}
        backgroundInline={backgroundInline}
        sharedTheme={sharedTheme}
      />
    );
  }

  renderResumeWithProfile() {
    const {
      backgroundInline,
      moreBenefitsText,
      onResumeWithProfileShownAnalytics,
      perksHeader,
      profilePerks,
      profileSignInTheme,
      restartButtonText,
      resumeWithProfileConfig,
      resumeWithProfileOpenSignIn,
      resumeWithProfileOpenSignUp,
      signInButtonText,
      signUpButtonText,
    } = this.props;
    const { renderResumeWithProfile } = this.state;

    const playFromBeginning = _.get(resumeWithProfileConfig, 'playFromBeginning', null);

    const overlayText = {
      signInButtonText,
      signUpButtonText,
      restartButtonText,
      moreBenefitsText,
    };

    return (
      <ResumeWithProfile
        backgroundInline={backgroundInline}
        isActive={renderResumeWithProfile}
        theme={profileSignInTheme}
        perksHeader={perksHeader}
        profilePerks={profilePerks}
        overlayText={overlayText}
        openSignIn={resumeWithProfileOpenSignIn}
        openSignUp={resumeWithProfileOpenSignUp}
        playFromBeginning={playFromBeginning}
        onRender={onResumeWithProfileShownAnalytics}
      />
    );
  }

  renderResumeWithoutProfile() {
    const { resumeWithProfileConfig, showResumeCTA } = this.props;
    const restart = _.get(resumeWithProfileConfig, 'playFromBeginning', null);
    const play = _.get(resumeWithProfileConfig, 'play', null);

    return <ResumeWithoutProfile restart={restart} play={play} isActive={showResumeCTA} />;
  }

  renderUpsellError() {
    const {
      backgroundUrl,
      setOverlay,
      sharedTheme,
      upsellErrorTheme,
      upsellErrorChildren,
      upsellErrorBackgroundClass,
      upsellErrorInnerContainerChildren,
      upsellErrorOnClose,
    } = this.props;
    const { renderUpsellError, upsellConfirmClicked, upsellUrl } = this.state;
    const onClose = () => {
      if (upsellErrorOnClose) upsellErrorOnClose();
    };
    const innerContainerChildrenParams = { onClose };

    const onClickConfirmError = () => {
      const mvpdWindow = AuthClientless.openMvpdWindow();
      this.setState({
        renderUpsellConfirm: true,
        renderUpsellError: false,
      });
      setOverlay(OVERLAY_AUTH_UPSELL_ERROR, false);
      setOverlay(OVERLAY_AUTH_UPSELL_CONFIRM);
      mvpdWindow.location = upsellUrl;
      return mvpdWindow;
    };
    const upsellErrorChildrenProps = {
      onClick: upsellConfirmClicked ? onClickConfirmError : upsellErrorOnClose,
      upsellConfirmClicked,
    };

    return (
      <UpsellError
        key="upsellError"
        rendered={renderUpsellError}
        sharedTheme={sharedTheme}
        backgroundClass={upsellErrorBackgroundClass}
        backgroundUrl={backgroundUrl}
        theme={upsellErrorTheme}
        innerContainerChildren={upsellErrorInnerContainerChildren}
        innerContainerChildrenParams={innerContainerChildrenParams}
      >
        {upsellErrorChildren(upsellErrorChildrenProps)}
      </UpsellError>
    );
  }

  renderUpsellConfirm() {
    const {
      backgroundUrl,
      setOverlay,
      sharedTheme,
      upsellConfirmTheme,
      upsellConfirmChildren,
      upsellConfirmBackgroundClass,
      upsellConfirmInnerContainerChildren,
      upsellConfirmOnClose,
    } = this.props;
    const { renderUpsellConfirm } = this.state;
    const onClose = () => {
      if (upsellConfirmOnClose) upsellConfirmOnClose();
    };
    const onClick = () => {
      setOverlay(OVERLAY_AUTH_UPSELL_CONFIRM, false);
      setOverlay(OVERLAY_AUTH_MVPD_START);
      this.setState({
        renderUpsellConfirm: false,
        renderMVPDStart: true,
        renderLoading: false,
        upsellConfirmClicked: true,
      });
    };
    const innerContainerChildrenParams = { onClose };
    return (
      <UpsellConfirm
        key="upsellConfirm"
        rendered={renderUpsellConfirm}
        sharedTheme={sharedTheme}
        backgroundClass={upsellConfirmBackgroundClass}
        backgroundUrl={backgroundUrl}
        theme={upsellConfirmTheme}
        innerContainerChildren={upsellConfirmInnerContainerChildren}
        innerContainerChildrenParams={innerContainerChildrenParams}
      >
        {upsellConfirmChildren({ onClick })}
      </UpsellConfirm>
    );
  }

  renderMvpdDirectSignInRedirect() {
    const {
      backgroundUrl,
      setOverlay,
      sharedTheme,
      mvpdDirectSignInTheme,
      mvpdDirectSignInChildren,
      mvpdDirectSignInBackgroundClass,
      mvpdDirectSignInInnerContainerChildren,
    } = this.props;
    const { mvpdBuythroughData, renderMvpdDirectSignInRedirect } = this.state;
    const onUpgradeClick = () => {
      const upsellUrl = _.get(mvpdBuythroughData, 'url');
      const mvpdWindow = AuthClientless.openMvpdWindow();
      this.setState({
        renderUpsellConfirm: true,
        renderMvpdDirectSignInRedirect: false,
      });
      setOverlay(OVERLAY_AUTH_UPSELL_CONFIRM);
      mvpdWindow.location = upsellUrl;
    };

    return (
      <MvpdDirectSignInRedirect
        key="mvpdDirectSignInRedirect"
        rendered={renderMvpdDirectSignInRedirect}
        sharedTheme={sharedTheme}
        backgroundClass={mvpdDirectSignInBackgroundClass}
        backgroundUrl={backgroundUrl}
        theme={mvpdDirectSignInTheme}
        innerContainerChildren={mvpdDirectSignInInnerContainerChildren}
      >
        {mvpdDirectSignInChildren({ onUpgradeClick })}
      </MvpdDirectSignInRedirect>
    );
  }

  renderPreviewPassWelcome() {
    const { renderPreviewPassWelcome } = this.state;
    const {
      previewPassWelcomeText,
      previewPassWelcomeNetworkLogo,
      mvpd,
      backgroundUrl,
    } = this.props;
    if (!renderPreviewPassWelcome) return null;
    return (
      <PreviewPassWelcome
        key="previewPassWelcome"
        rendered={renderPreviewPassWelcome}
        networkLogo={previewPassWelcomeNetworkLogo}
        dismiss={() => this.togglePreviewPassWelcome(false)}
        mvpd={mvpd}
        backgroundUrl={backgroundUrl}
      >
        {previewPassWelcomeText({ mvpd })}
      </PreviewPassWelcome>
    );
  }

  render() {
    const cookiesBlocked = this.renderCookiesBlocked();
    const expiredPreviewPass = this.renderExpiredPreviewPass();
    const failure = this.renderFailure();
    const geoLocationError = this.renderGeoLocationError();
    const loading = this.renderLoading();
    const mvpdDirectSignInRedirect = this.renderMvpdDirectSignInRedirect();
    const mvpdIncomplete = this.renderMVPDIncomplete();
    const mvpdRetry = this.renderMVPDRetry();
    const mvpdSearch = this.renderMVPDSearch();
    const mvpdStart = this.renderMVPDStart();
    const noSportsOnMobile = this.renderNoSportsOnMobile();
    const notEntitled = this.renderNotEntitled();
    const playbackError = this.renderPlaybackError();
    const profilePcsError = this.renderProfilePcsError();
    const redirectingMVPDUpsell = this.renderMVPDUpsellRedirecting();
    const resumeWithProfile = this.renderResumeWithProfile();
    const resumeWithoutProfile = this.renderResumeWithoutProfile();
    const signIn = this.renderSignIn();
    const mvpdExpire = this.renderMVPDExpireSignIn();
    const unlockUpsell = this.renderUnlockUpsell();
    const success = this.renderSuccess();
    const upsellConfirm = this.renderUpsellConfirm();
    const upsellError = this.renderUpsellError();
    const previewPassWelcome = this.renderPreviewPassWelcome();

    return (
      <div>
        {resumeWithProfile}
        {resumeWithoutProfile}
        {cookiesBlocked}
        {expiredPreviewPass}
        {geoLocationError}
        {mvpdDirectSignInRedirect}
        {mvpdSearch}
        {mvpdStart}
        {mvpdRetry}
        {mvpdIncomplete}
        {noSportsOnMobile}
        {notEntitled}
        {playbackError}
        {unlockUpsell}
        {signIn}
        {mvpdExpire}
        {success}
        {loading}
        {profilePcsError}
        {redirectingMVPDUpsell}
        {failure}
        {upsellConfirm}
        {upsellError}
        {previewPassWelcome}
      </div>
    );
  }
}

AuthClientless.defaultProps = {
  account: null,
  anonymousAccount: null,
  additionalAuthorizedNetworks: {},
  anonymousId: '',
  anonymousLogin: null,
  authEndpointConfig: null,
  authenticationRedirectUrl: null,
  authenticationSelectProviderStarted: noop,
  authenticationStarted: noop,
  authorizationToken: '',
  authZErrorMapping: {},
  background: '',
  backgroundInline: null,
  backgroundUrl: null,
  blockMVPDIncomplete: false,
  blockSuccessScreen: false,
  clearTimeout: null,
  closeAccount: null,
  contentBlackoutActive: null,
  contentChildren: null,
  contentRating: null,
  cookiesBlockedTheme: {},
  entitlementIssues: null,
  failureTheme: {},
  fetchMVPDProviders: noop,
  geoLocationDeclined: null,
  geoLocationErrorChildren: null,
  geoLocationPrimaryActionCallback: noop,
  geoLocationText: '',
  geoLocationTimeoutFail: null,
  getCookiesBlockedChildren: null,
  isLive: false,
  isLiveRestart: null,
  isMobile: null,
  isTablet: null,
  isTveEnabled: true,
  loadingBackgroundClass: null,
  loadingInnerContainerChildren: null,
  loadingOnClose: null,
  loadingTheme: {},
  model: '',
  moreBenefitsText: '',
  mvpd: '',
  mvpdDirectSignInBackgroundClass: '',
  mvpdDirectSignInChildren: null,
  mvpdDirectSignInInnerContainerChildren: noop,
  mvpdDirectSignInTheme: {},
  mvpdExpired: false,
  mvpdIncompleteChildren: null,
  mvpdIncompleteTheme: {},
  mvpdLoginProfile: null,
  mvpdRetryChildren: null,
  mvpdRetryTheme: {},
  mvpdSearchBackgroundClass: '',
  mvpdSearchChildren: null,
  mvpdSearchInnerContainerChildren: null,
  mvpdSearchInput: noop,
  mvpdSearchOnClose: null,
  mvpdSearchOnInputChange: null,
  mvpdSearchResults: noop,
  mvpdSearchTheme: {},
  mvpdSignInTrigger: false,
  mvpdStartBackgroundClass: '',
  mvpdStartChildren: null,
  mvpdStartInnerContainerChildren: null,
  mvpdStartOnClose: noop,
  network: '',
  networkLogo: '',
  noSportsOnMobileErrorChildren: null,
  noSportsText: {},
  notEntitledChildren: null,
  notEntitledTheme: {},
  onAuthCheckComplete: null,
  onAuthFailure: noop,
  onAuthSuccess: null,
  onRef: null,
  onResumeWithProfileShownAnalytics: null,
  osName: '',
  perksHeader: null,
  playbackErrorChildren: null,
  playbackErrorTheme: {},
  previewPassEnabled: null,
  previewPassExpired: false,
  previewPassOnOpenOverlay: null,
  previewPassSignIn: false,
  previewPassWelcomeText: noop,
  previewPassWelcomeNetworkLogo: '',
  profileId: '',
  profilePcsErrorChildren: null,
  profilePcsErrorTheme: {},
  profilePerks: [],
  profileSignInTheme: {},
  ratingNoAuthZText: {},
  redirectingBackgroundClass: '',
  redirectingInnerContainerChildren: null,
  redirectingOnClose: null,
  redirectingTheme: {},
  releaseURL: '',
  renderCookiesBlocked: false,
  renderExpiredPreviewPass: false,
  renderVideoProviderSearch: null,
  requestSignIn: false,
  requiresAuth: null,
  requiresAuthLive: null,
  resetShowCookiesBlocked: null,
  resetSingleProviderSignInClicked: null,
  restartButtonText: '',
  resumeWithProfileConfig: {},
  resumeWithProfileOpenSignIn: null,
  resumeWithProfileOpenSignUp: null,
  selectedChannel: null,
  setAuthError: noop,
  setAuthorizationToken: noop,
  setIsAuthenticated: noop,
  setSegmentPageStartSource: noop,
  setMVPDSignInTrigger: null,
  setMVPDToAppState: null,
  setPreAuthCheckComplete: noop,
  setPreauthorizedResources: noop,
  setProvider: noop,
  setTimeout: null,
  setToken: null,
  setVideoOverlay: noop,
  sharedTheme: {},
  shouldCheckPreviewPass: null,
  showLoaderAfterAuth: false,
  showNoSportsOnMobileError: false,
  showProvidersHandler: null,
  showResumeCTA: false,
  showSignIn: false,
  signInButtonText: '',
  signInInvertContent: null,
  signInOnButtonClick: null,
  signInPerks: null,
  signInText: '',
  signInTheme: {},
  signUpButtonText: '',
  singleProviderId: '',
  singleProviderSignInClicked: null,
  successCookieName: '',
  successInnerContainerChildren: null,
  successTheme: {},
  tealiumAuthenticationStarted: () => {},
  triggerAuthCheck: null,
  tvProviderFeatListViewed: noop,
  tvProviderFullListViewed: noop,
  type: '',
  unlockUpsellInButtonText: '',
  unlockUpsellPerks: null,
  unlockUpsellText: '',
  upsellConfirmBackgroundClass: '',
  upsellConfirmChildren: null,
  upsellConfirmInnerContainerChildren: null,
  upsellConfirmOnClose: null,
  upsellConfirmTheme: {},
  upsellErrorBackgroundClass: '',
  upsellErrorChildren: null,
  upsellErrorInnerContainerChildren: null,
  upsellErrorOnClose: null,
  upsellErrorTheme: {},
  useMVPDRetry: null,
  videoId: null,
};

AuthClientless.propTypes = {
  account: PropTypes.shape({}),
  anonymousAccount: PropTypes.shape({}),
  additionalAuthorizedNetworks: PropTypes.shape({}),
  anonymousId: PropTypes.string,
  anonymousLogin: PropTypes.func,
  apiKey: PropTypes.string.isRequired,
  authEndpointConfig: PropTypes.shape({}),
  authenticationRedirectUrl: PropTypes.string,
  authenticationSelectProviderStarted: PropTypes.func,
  authenticationStarted: PropTypes.func,
  authorizationToken: PropTypes.string,
  authZErrorMapping: PropTypes.shape({}),
  background: PropTypes.string,
  backgroundInline: PropTypes.shape({}),
  backgroundUrl: PropTypes.string,
  blockMVPDIncomplete: PropTypes.bool,
  blockSuccessScreen: PropTypes.bool,
  clearTimeout: PropTypes.func,
  closeAccount: PropTypes.func,
  contentBlackoutActive: PropTypes.bool,
  contentChildren: PropTypes.func,
  contentRating: PropTypes.string,
  cookiesBlockedTheme: PropTypes.shape({}),
  deviceId: PropTypes.string.isRequired,
  entitlementIssues: PropTypes.arrayOf(PropTypes.shape({})),
  failureTheme: PropTypes.shape({}),
  fetchMVPDProviders: PropTypes.func,
  geoLocationDeclined: PropTypes.bool,
  geoLocationErrorChildren: PropTypes.func,
  geoLocationPrimaryActionCallback: PropTypes.func,
  geoLocationText: PropTypes.string,
  geoLocationTimeoutFail: PropTypes.bool,
  getCookiesBlockedChildren: PropTypes.func,
  handlePopInMiniPlayer: PropTypes.func,
  isLive: PropTypes.bool,
  isLiveRestart: PropTypes.bool,
  isMiniPlayerActive: PropTypes.bool,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  isTveEnabled: PropTypes.bool,
  loadingBackgroundClass: PropTypes.string,
  loadingInnerContainerChildren: PropTypes.func,
  loadingOnClose: PropTypes.func,
  loadingTheme: PropTypes.shape({}),
  model: PropTypes.string,
  moreBenefitsText: PropTypes.string,
  mvpd: PropTypes.string,
  mvpdCookieName: PropTypes.string.isRequired,
  mvpdDirectSignInBackgroundClass: PropTypes.string,
  mvpdDirectSignInChildren: PropTypes.func,
  mvpdDirectSignInInnerContainerChildren: PropTypes.func,
  mvpdDirectSignInTheme: PropTypes.shape({}),
  mvpdExpired: PropTypes.bool,
  mvpdIncompleteChildren: PropTypes.func,
  mvpdIncompleteTheme: PropTypes.shape({}),
  mvpdLoginProfile: PropTypes.bool,
  mvpdRetryChildren: PropTypes.func,
  mvpdRetryTheme: PropTypes.shape({}),
  mvpdSearchBackgroundClass: PropTypes.string,
  mvpdSearchChildren: PropTypes.node,
  mvpdSearchInnerContainerChildren: PropTypes.func,
  mvpdSearchInput: PropTypes.func,
  mvpdSearchOnClose: PropTypes.func,
  mvpdSearchOnInputChange: PropTypes.func,
  mvpdSearchResults: PropTypes.func,
  mvpdSearchTheme: PropTypes.shape({}),
  mvpdSignInTrigger: PropTypes.bool,
  mvpdStartBackgroundClass: PropTypes.string,
  mvpdStartChildren: PropTypes.func,
  mvpdStartInnerContainerChildren: PropTypes.func,
  mvpdStartOnClose: PropTypes.func,
  network: PropTypes.string,
  networkLogo: PropTypes.string,
  noSportsOnMobileErrorChildren: PropTypes.func,
  noSportsText: PropTypes.shape({}),
  notEntitledChildren: PropTypes.func,
  notEntitledTheme: PropTypes.shape({}),
  onAuthCheckComplete: PropTypes.func,
  onAuthFailure: PropTypes.func,
  onAuthSuccess: PropTypes.func,
  onRef: PropTypes.func,
  onResumeWithProfileShownAnalytics: PropTypes.func,
  osName: PropTypes.string,
  pcs: PropTypes.shape({}).isRequired,
  perksHeader: PropTypes.node,
  playbackErrorChildren: PropTypes.func,
  playbackErrorTheme: PropTypes.shape({}),
  previewPassEnabled: PropTypes.bool,
  previewPassExpired: PropTypes.bool,
  previewPassOnOpenOverlay: PropTypes.func,
  previewPassSignIn: PropTypes.bool,
  previewPassWelcomeText: PropTypes.func,
  previewPassWelcomeNetworkLogo: PropTypes.string,
  profileId: PropTypes.string,
  profilePcsErrorChildren: PropTypes.func,
  profilePcsErrorTheme: PropTypes.shape({}),
  profilePerks: PropTypes.arrayOf(PropTypes.node),
  profileSignInTheme: PropTypes.shape({}),
  ratingNoAuthZText: PropTypes.shape({}),
  redirectingBackgroundClass: PropTypes.string,
  redirectingInnerContainerChildren: PropTypes.func,
  redirectingOnClose: PropTypes.func,
  redirectingTheme: PropTypes.shape({}),
  releaseURL: PropTypes.string,
  renderCookiesBlocked: PropTypes.bool,
  renderExpiredPreviewPass: PropTypes.bool,
  renderVideoProviderSearch: PropTypes.func,
  requestSignIn: PropTypes.bool,
  requiresAuth: PropTypes.bool,
  requiresAuthLive: PropTypes.bool,
  resetShowCookiesBlocked: PropTypes.func,
  resetSingleProviderSignInClicked: PropTypes.func,
  restartButtonText: PropTypes.string,
  resumeWithProfileConfig: PropTypes.shape({}),
  resumeWithProfileOpenSignIn: PropTypes.func,
  resumeWithProfileOpenSignUp: PropTypes.func,
  selectedChannel: PropTypes.number,
  setAuthError: PropTypes.func,
  setAuthorizationToken: PropTypes.func,
  setIsAuthenticated: PropTypes.func,
  setSegmentPageStartSource: PropTypes.func,
  setMVPDSignInTrigger: PropTypes.func,
  setMVPDToAppState: PropTypes.func,
  setOverlay: PropTypes.func.isRequired,
  setPreAuthCheckComplete: PropTypes.func,
  setPreauthorizedResources: PropTypes.func,
  setProvider: PropTypes.func,
  setTimeout: PropTypes.func,
  setToken: PropTypes.func,
  setVideoOverlay: PropTypes.func,
  sharedTheme: PropTypes.shape({}),
  shouldCheckPreviewPass: PropTypes.bool,
  showLoaderAfterAuth: PropTypes.bool,
  showNoSportsOnMobileError: PropTypes.bool,
  showProvidersHandler: PropTypes.func,
  showResumeCTA: PropTypes.bool,
  showSignIn: PropTypes.bool,
  signInButtonText: PropTypes.string,
  signInInvertContent: PropTypes.bool,
  signInOnButtonClick: PropTypes.func,
  signInPerks: PropTypes.shape({}),
  signInText: PropTypes.string,
  signInTheme: PropTypes.shape({}),
  signUpButtonText: PropTypes.string,
  singleProviderId: PropTypes.string,
  singleProviderSignInClicked: PropTypes.bool,
  successCookieName: PropTypes.string,
  successInnerContainerChildren: PropTypes.func,
  successTheme: PropTypes.shape({}),
  tealiumAuthenticationStarted: PropTypes.func,
  triggerAuthCheck: PropTypes.bool,
  tvProviderFeatListViewed: PropTypes.func,
  tvProviderFullListViewed: PropTypes.func,
  type: PropTypes.string,
  unlockUpsellInButtonText: PropTypes.string,
  unlockUpsellPerks: PropTypes.shape({}),
  unlockUpsellText: PropTypes.string,
  upsellConfirmBackgroundClass: PropTypes.string,
  upsellConfirmChildren: PropTypes.func,
  upsellConfirmInnerContainerChildren: PropTypes.func,
  upsellConfirmOnClose: PropTypes.func,
  upsellConfirmTheme: PropTypes.shape({}),
  upsellErrorBackgroundClass: PropTypes.string,
  upsellErrorChildren: PropTypes.func,
  upsellErrorInnerContainerChildren: PropTypes.func,
  upsellErrorOnClose: PropTypes.func,
  upsellErrorTheme: PropTypes.shape({}),
  useMVPDRetry: PropTypes.bool,
  videoId: PropTypes.string,
};

const mapStateToProps = state => ({
  isMiniPlayerActive: state.globalVideo.isMiniPlayerActive,
  pcs: makeSelectAppPCS(state),
});

export default connect(mapStateToProps)(ReactTimeout(AuthClientless));
